import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { faClosedCaptioning } from '@fortawesome/free-solid-svg-icons';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: 500,
    width: 800,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black',
    opacity: 1,
    'overflowY': 'scroll',
};
const ModalDetalleProducto = (props) => {


    let texto = props.texto
    const { api = undefined } = props
    const { VerModalDetalle, dataDetalle, detalleMarcas = undefined } = api
    /******Modal */
    const [openModal, setOpenModal] = React.useState(detalleMarcas);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')

    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        VerModalDetalle(false)
        //resetValores({ validacion: false, texto: '' })
    }

    return (
        <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description" hideBackdrop={true} >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black", textAlign: 'center' }}>
                    Detalle del producto
                </Typography>
                <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'center' }}>
                    <Fragment>
                        <table className="table table-bordered">
                            <thead className='text-center labelNaranja'>
                                <tr>
                                    <th >Dato</th>
                                    <th >Descripcion</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='text-start'> Tipo de bebida: </td>
                                    <td className='text-start'>{dataDetalle.tipobebida}</td>
                                </tr>
                                <tr>
                                    <td className='text-start'> % Alc. Vol.: </td>
                                    <td className='text-start'> {dataDetalle.contenidoalcoholico} </td>
                                </tr>
                                <tr>
                                    <td className='text-start'> Número de análisis de la bebida: </td>
                                    <td className='text-start'> {dataDetalle.numeroanalisisbebida} </td>
                                </tr>
                                <tr>
                                    <td className='text-start'> Marca: </td>
                                    <td className='text-start'>{dataDetalle.marca}</td>
                                </tr>
                                <tr>
                                    <td className='text-start'> Ingrediente/Sabor: </td>
                                    <td className='text-start'> {dataDetalle.ingrediente} </td>
                                </tr>
                                <tr>
                                    <td className='text-start'> Número de lote envasado: </td>
                                    <td className='text-start'> {dataDetalle.numerolote} </td>
                                </tr>
                                <tr>
                                    <td className='text-start'> Contenido neto: </td>
                                    <td className='text-start'> {dataDetalle.contenidonetobotella + ' ' + dataDetalle.unidad} </td>
                                </tr>
                                <tr>
                                    <td className='text-start'> Número de botellas: </td>
                                    <td className='text-start'> {dataDetalle.numerobotellas} </td>
                                </tr>
                                <tr>
                                    <td className='text-start'> Número de cajas: </td>
                                    <td className='text-start'> {dataDetalle.numerocajas} </td>
                                </tr>
                                <tr>
                                    <th colSpan={2} className='text-center' style={{background:'#c88b3e', color:'white'}}> Descripción de mezcal utilizado</th>
                                </tr>
                                <tr>
                                    <td className='text-start'> Número de análisis granel: </td>
                                    <td className='text-start'> {dataDetalle.numeroanalisisgranel}</td>
                                </tr>
                                <tr>
                                    <td className='text-start'> Número de certificado: </td>
                                    <td className='text-start'> {dataDetalle.numerocertificado} </td>
                                </tr>
                                <tr>
                                    <td className='text-start'> Número de lote a granel: </td>
                                    <td className='text-start'> {dataDetalle.numerolotegranel} </td>
                                </tr>


                            </tbody>
                        </table>
                    </Fragment>
                </Typography>
                <br />
                <div className='text-center'>
                    <button className={`btn btn-success`} type='button' style={{ width: '50%' }} onClick={() => handleCloseModal()}>Cerrar</button>
                </div>
            </Box>
        </Modal>
    )
};

export default withRouter(ModalDetalleProducto)
